import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  setAllUsers,
  addRegisteredUser,
  setSingleUser,
  setUsersTotalPages,
  setAllUsersCurrentPage,
  setAccessList,
  setAccessListCurrentPage,
  setAccessListTotalPages,
  removeSingleUserAccess,
  setAccessManagementList,
  setAccessMangementListCurrentPage,
  setAccessManagementListTotalPages,
  removeSingleUserAccessMangement,
  setAdminLogs,
  setAdminLogsCurrentPage,
  setAdminLog,
  setAdminLogsTotalPages,
  setAdminLogDB,
} from "../../redux/actions/Users";
import axios from "../auth/jwt/config";

const UsersRequests = {
  getAllUsers: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/user/getallusers?page=${page}&limit=50`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllUsers(data.docs));
            dispatch(setAllUsersCurrentPage(data.page));
            dispatch(setUsersTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAccessList: (page) => {
    return (dispatch) => {
      axios
        .get(`/mainAccessList/getall?page=${page}&limit=50`)
        .then(({ data }) => {
          dispatch(fetchSuccess());
          dispatch(setAccessList(data.docs));
          dispatch(setAccessListCurrentPage(data.page));
          dispatch(setAccessListTotalPages(data.totalPages));
        })
        .catch((error) => {
          if (error.response) {
            dispatch(fetchError(error.response.data.msg));
          } else {
            dispatch(fetchError(error.message));
          }
        });
    };
  },
  searchAllUsers: (page, searchParam) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/user/getallusers?page=${page}&limit=50&searchString=${searchParam}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllUsers(data.docs));
            dispatch(setAllUsersCurrentPage(data.page));
            dispatch(setUsersTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  searchAccessList: (page, searchParam) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/mainAccessList/getall?page=${page}&limit=30&searchString=${searchParam.toString()}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAccessList(data.docs));
            dispatch(setAccessListCurrentPage(data.page));
            dispatch(setAccessListTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  registerUser: (userData) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post("/user/adduser", {
            name: userData.name,
            phone: userData.phone,
            password: userData.password,
          })
          .then(({ data }) => {
            dispatch(addRegisteredUser(data.user));
            dispatch(fetchSuccess("با موفقیت اضافه شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getUserById: (userId) => {
    return (dispatch) => {
      dispatch(fetchStart());
      try {
        axios
          .get(`/user/getuser/${userId}`)
          .then(({ data }) => {
            const { user } = data;
            dispatch(fetchSuccess());
            dispatch(setSingleUser(user));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateSingleUser: (userData, userId) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/user/update/Admin/${userId}`, userData)
          .then(({ data }) => {
            dispatch(fetchSuccess(data.messageFa));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleUserAccess: (userId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/mainAccessList/remove/${userId}`)
          .then(() => {
            dispatch(removeSingleUserAccess(userId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                UsersRequests.getAccessList(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addSingleUserAccess: (user) => {
    return (dispatch) => {
      try {
        axios
          .post(`/mainAccessList/addsingle`, user)
          .then(() => {
            setTimeout(() => {
              dispatch(fetchSuccess("با موفقیت اضافه شد"));
            }, 500);
            UsersRequests.getAccessList(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addBatchUserAccess: (file) => {
    return async (dispatch) => {
      const formData = new FormData();
      formData.append("csvFile", file);
      try {
        axios
          .post(`/mainAccessList/addbatch`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => {
            setTimeout(() => {
              dispatch(
                fetchSuccess(`${data.addedUserCount} مورد با موفقیت اضافه شد`)
              );
            }, 500);
            UsersRequests.getAccessList(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError("مشکل در آپلود "));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateUserPass: (pass, passRep, userId) => {
    return (dispatch) => {
      if (pass !== passRep) {
        dispatch(fetchError("رمز عبور و تکرار آن باید یکسان باشد"));
      } else {
        try {
          axios
            .patch(`/user/update/password/Admin/${userId}`, {
              newPassword: pass,
            })
            .then(({ data }) => {
              dispatch(fetchSuccess(data.messageFa));
            })
            .catch((error) => {
              if (error.response) {
                dispatch(fetchError(error.response.data.msgFa));
              } else {
                dispatch(fetchError(error.message));
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
        }
      }
    };
  },
  // access list requests
  getAccessMList: (page) => {
    return (dispatch) => {
      axios
        .get(`/accessList/getall?page=${page}&limit=50`)
        .then(({ data }) => {
          dispatch(fetchSuccess());
          dispatch(setAccessManagementList(data.docs));
          dispatch(setAccessMangementListCurrentPage(data.page));
          dispatch(setAccessManagementListTotalPages(data.totalPages));
        })
        .catch((error) => {
          if (error.response) {
            dispatch(fetchError(error.response.data.msg));
          } else {
            dispatch(fetchError(error.message));
          }
        });
    };
  },
  searchAccessMList: (page, searchParam) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/accesslist/getall?page=${page}&limit=30&searchString=${searchParam.toString()}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAccessManagementList(data.docs));
            dispatch(setAccessMangementListCurrentPage(data.page));
            dispatch(setAccessManagementListTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addSingleUserAccessMangement: (user) => {
    return (dispatch) => {
      try {
        axios
          .post(`/accesslist/addsingle`, user)
          .then(() => {
            setTimeout(() => {
              dispatch(fetchSuccess("با موفقیت اضافه شد"));
            }, 500);
            UsersRequests.getAccessMList(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addBatchUserAccessManagement: (file, data) => {
    return async (dispatch) => {
      const formData = new FormData();
      formData.append("csvFile", file);
      try {
        axios
          .post(
            `/accesslist/addbatch?topic=${data.topic}&type=${data.type}${
              data?.topicString ? `&topicString=${data.topicString}` : ""
            }`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(({ data }) => {
            dispatch(
              fetchSuccess(`${data.addedUserCount} مورد با موفقیت اضافه شد`)
            );
            UsersRequests.getAccessMList(1)(dispatch);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError("مشکل در آپلود "));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleUserAccessMangement: (userId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/accesslist/remove/${userId}`)
          .then(() => {
            dispatch(removeSingleUserAccessMangement(userId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                UsersRequests.getAccessMList(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAdminLogs: (page, searchStr, selectedAdminLogDB) => {
    return (dispatch) => {
      try {
        axios
          .get(
            `/adminlog/getall?page=${page}&limit=100&searchString=${searchStr ||
              ""}&dbName=${selectedAdminLogDB || ""}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAdminLogs(data.docs));
            dispatch(setAdminLogsCurrentPage(data.page));
            dispatch(setAdminLogsTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAdminLogById: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/adminlog/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAdminLog(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getAdminLogsDB: () => {
    return (dispatch) => {
      try {
        axios
          .get(`/adminlog/getdbs`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAdminLogDB(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default UsersRequests;
